/* eslint-disable import-alias/import-alias*/

import React from 'react';
import { Provider } from 'react-redux';
import store from '@state/store';
import { AlternativeProduct } from './AlternativeProduct';



export const ProvideAlternativeProduct = (props: any) => {

  return (
    <Provider store={store}>
      <AlternativeProduct {...props} />
    </Provider>
  );
};
